import { SearchOutlined } from '@ant-design/icons'
import { Card, Flex, Input } from 'antd'

// NOTE: Status filter (All Status / Published / Draft) removed - BE chưa support status.
// Khi BE bổ sung, restore status prop, Select component và PROPERTY_ACTIVITY_STATUS_FILTER_OPTIONS.

interface ActivityListFilterProps {
  searchText: string
  onSearchChange: (value: string) => void
}

export const ActivityListFilter = ({ searchText, onSearchChange }: ActivityListFilterProps) => {
  return (
    <Card className="property-activities__filter-card" styles={{ body: { padding: 16 } }}>
      <Flex gap={16} align="center">
        <Input
          placeholder="Search activities..."
          prefix={<SearchOutlined style={{ color: '#9ca3af' }} />}
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          allowClear
          style={{ flex: 1 }}
        />
      </Flex>
    </Card>
  )
}
